var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "room-displays" } }, [
    _vm.room && _vm.room.displays.length
      ? _c(
          "div",
          [
            _c("div", { staticClass: "va-subtitle" }, [
              _vm._v(_vm._s(_vm.$t("common.displayInformation")))
            ]),
            !_vm.init
              ? _c("v-progress-circular", {
                  attrs: { color: "accent", indeterminate: "" }
                })
              : _vm._l(_vm.displays, function(display, index) {
                  return _c("va-card", { key: index, staticClass: "my-4" }, [
                    _c("div", { staticClass: "d-flex justify-space-between" }, [
                      _c("div", { staticClass: "text-xl font-bold mb-3" }, [
                        _vm._v(" " + _vm._s(display.deviceName) + " ")
                      ])
                    ]),
                    _c("div", { staticClass: "d-flex align-center" }, [
                      _c(
                        "div",
                        {
                          staticClass: "display-container",
                          style: {
                            minWidth: _vm.maxWidth * _vm.scaleFactor + "px"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "display",
                              class: {
                                primary: display.isPrimary,
                                screenshot: display.preview
                              },
                              style: _vm.displayStyle(display)
                            },
                            [
                              _vm.processing
                                ? _c("v-progress-circular", {
                                    attrs: {
                                      indeterminate: "",
                                      color: display.isPrimary
                                        ? "white"
                                        : "accent"
                                    }
                                  })
                                : _c("span", { staticClass: "index" }, [
                                    _vm._v(
                                      _vm._s(
                                        display.index
                                          ? display.index
                                          : index + 1
                                      )
                                    )
                                  ])
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "ml-6 flex-grow-1" },
                        [
                          _c(
                            "va-info-row",
                            { attrs: { label: _vm.$t("common.type") } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    display.isPrimary
                                      ? _vm.$t("common.primary")
                                      : _vm.$t("common.extended")
                                  ) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "va-info-row",
                            { attrs: { label: _vm.$t("common.refreshRate") } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(display.refreshRate) + " Hz")
                              ]),
                              display.refreshRate < 30
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "d-inline-flex align-center warning--text ml-1"
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: { small: "", color: "warning" }
                                        },
                                        [_vm._v("mdi-alert-outline")]
                                      ),
                                      _c("small", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("common.low").toUpperCase()
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          ),
                          _c(
                            "va-info-row",
                            { attrs: { label: _vm.$t("common.sizes") } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(display.width) +
                                  " x " +
                                  _vm._s(display.height) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "va-info-row",
                            {
                              attrs: { label: _vm.$t("common.diagonalInches") }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(display.diagonalInches) + "″ "
                              )
                            ]
                          ),
                          _c(
                            "va-info-row",
                            { attrs: { label: _vm.$t("common.densityDpi") } },
                            [_vm._v(" " + _vm._s(display.densityDpi) + " ")]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }